import axios, { AxiosInstance } from "axios";
import { getCookie } from "../../utils/cookie";
import { attachSessionExpiryHandler } from "../sessionExpiry";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_DERIN_API || "http://localhost:3002",
});

apiClient.interceptors.request.use((config: any) => {
  config.headers.Authorization = `Bearer ${getCookie()}`;
  config.headers.transactionid = process.env.REACT_APP_TRANSACTION_ID;

  return config;
});

// The derin API requires a token on every route it exposes to this portal and
// answers 401 once ours has expired.
attachSessionExpiryHandler(apiClient);

const apiClientNoAuth = axios.create({
  baseURL: process.env.REACT_APP_DERIN_API || "http://localhost:3002",
});

export const derinApiClient = (): AxiosInstance => apiClient;

export const derinApiClientNoAuth = (): AxiosInstance => apiClientNoAuth;
